<template>
  <LoadingWrapper :state="status">
    <PrepareEvaluationSlideAnalysis
      :all-surveys="data.surveys"
      :feedback-topic="data.feedbackTopic"
      :scale="data.scale"
      :slide-properties="data.slideProperties"
      @dirty="setDirty"
    />
    <UnsavedChangesDialog
      :is-open="showConfirmDialog"
      @confirm="confirmLeave"
      @dismiss="cancelLeave"
    />
  </LoadingWrapper>
</template>
<script lang="ts" setup>
  import LoadingWrapper from '../../../core/components/loading/LoadingWrapper.vue'
  import { usePrepareEvaluationSlide } from '../composable/use-prepare-evaluation-slide'
  import PrepareEvaluationSlideAnalysis from './PrepareEvaluationSlideAnalysis.vue'
  import { useRoute } from 'vue-router'
  import { computed } from 'vue'
  import { useUnsavedChanges } from '@/core/composables/use-unsaved-changes'
  import UnsavedChangesDialog from '@/core/components/unsaved-changes-dialog/UnsavedChangesDialog.vue'

  const route = useRoute()
  const feedbackTopicId = computed(() => route.params.feedbackTopicId as string)
  const { status, data } = usePrepareEvaluationSlide(feedbackTopicId)

  const { showConfirmDialog, confirmLeave, cancelLeave, setDirty } = useUnsavedChanges()
</script>
